import { FC, useRef } from 'react';
import { GoalCenter, GoalValue } from './WeeklyGoalWrapper';
import WeeklyGoalCore from './WeeklyGoalCore';
import SecondEmpty from './WeeklyIcons/SecondEmpty';
import FirstEmpty from './WeeklyIcons/FirstEmpty';
import SecondComplete from './WeeklyIcons/SecondComplete';
import FirstComplete from './WeeklyIcons/FirstComplete';
import EyeBrow from './WeeklyIcons/EyeBrow';
import ThreeCompleted from './WeeklyIcons/ThreeCompleted';
import FourCompleted from './WeeklyIcons/FourCompleted';
import FiveCompleted from './WeeklyIcons/FiveCompleted';
interface Props {
  goalValues: GoalValue[] | null;
  goalCenter: GoalCenter | null;
}

const WeeklyGoal: FC<Props> = ({ goalValues, goalCenter }) => {
  const triggerCenterRef = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <div className="tw-flex tw-flex-row">
        <WeeklyGoalCore
          triggerCenterRef={triggerCenterRef}
          centerClasses={goalCenter?.centerClasses ?? ''}
          goalValues={goalValues}
          openPanel={true}
        />
        <div className={`tw-flex ${goalValues && goalValues?.length >= 3 && 'tw-flex-row'}`}>
          {!goalValues?.length ? (
            <>
              <div className="tw-relative tw-right-[-12px] tw-top-[6px]">
                <SecondEmpty width="38" height="48" />
              </div>
              <div className="tw-relative tw-right-[8px] tw-top-[-1px]">
                <FirstEmpty width="38" height="48" />
              </div>
            </>
          ) : goalValues.length <= 2 ? (
            <>
              <div className="tw-relative tw-right-[-12px] tw-top-[6px]">
                {goalValues?.length === 2 && <SecondComplete width="38" height="48" />}
                {goalValues?.length === 1 && <SecondEmpty width="38" height="48" />}
              </div>
              <div className="tw-relative tw-right-[8px] tw-top-[-1px]">
                {goalValues?.length && goalValues?.length === 2 && <FirstComplete width="38" height="48" />}
                {goalValues?.length && goalValues?.length === 1 && <FirstComplete width="38" height="48" />}
              </div>
            </>
          ) : (
            <>
              {goalValues?.length && goalValues.length === 3 && (
                <>
                  <EyeBrow bottom="0" top="6" width="23" height="12" left="51" transform="12" />
                  <ThreeCompleted width="54" height="54" />
                </>
              )}
              {goalValues?.length && goalValues.length === 4 && (
                <>
                  <EyeBrow bottom="0" top={undefined} width="23" height="12" transform={undefined} />
                  <FourCompleted width="54" height="54" />
                </>
              )}
              {goalValues?.length && goalValues.length >= 5 && (
                <>
                  <EyeBrow bottom="0" top={undefined} width="23" height="12" transform={undefined} />
                  <FiveCompleted width="54" height="54" />
                </>
              )}
            </>
          )}
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default WeeklyGoal;
